<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-top">
        <div class="footer-section">
          <h3 class="footer-title">{{ $t('footer.product') }}</h3>
          <ul class="footer-links">
            <li><router-link to="/receive-code" class="footer-link">{{ $t('nav.receiveData') }}</router-link></li>
            <li><router-link to="/receive-records" class="footer-link">{{ $t('nav.receiveRecords') }}</router-link></li>
            <li><router-link to="/desktop-download" class="footer-link">{{ $t('nav.desktopDownload') }}</router-link></li>
            <li><router-link to="/international-projects" class="footer-link">{{ $t('footer.internationalProjects') }}</router-link></li>
            <li><a href="https://mobile.tqsms.xyz" target="_blank" rel="noopener noreferrer" class="footer-link">{{ $t('footer.mobileApp') }}</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h3 class="footer-title">{{ $t('footer.support') }}</h3>
          <ul class="footer-links">
            <li><a href="https://t.me/BelugaWhaleSMSBot" target="_blank" rel="noopener noreferrer" class="footer-link">{{ $t('footer.customerService') }}</a></li>
            <li><router-link to="/tickets?create=true" class="footer-link">{{ $t('nav.ticketCenter') }}</router-link></li>
            <li><router-link to="/faq" class="footer-link">{{ $t('nav.faq') }}</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h3 class="footer-title">{{ $t('footer.aboutUs') }}</h3>
          <p class="footer-text">{{ $t('brand.description') }}</p>
        </div>
        
        <div class="footer-section">
          <div class="footer-logo">
            <img src="@/assets/images/logo.svg" :alt="$t('brand.logo')" class="footer-logo-img">
            <span class="footer-logo-text">{{ $t('brand.name') }}</span>
          </div>
          <div class="footer-social">
            <a href="#" class="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.46 6C21.69 6.35 20.86 6.58 20 6.69C20.88 6.16 21.56 5.32 21.88 4.31C21.05 4.81 20.13 5.16 19.16 5.36C18.37 4.5 17.26 4 16 4C13.65 4 11.73 5.92 11.73 8.29C11.73 8.63 11.77 8.96 11.84 9.27C8.28 9.09 5.11 7.38 3 4.79C2.63 5.42 2.42 6.16 2.42 6.94C2.42 8.43 3.17 9.75 4.33 10.5C3.62 10.5 2.96 10.3 2.38 10V10.03C2.38 12.11 3.86 13.85 5.82 14.24C5.19 14.41 4.53 14.42 3.9 14.27C4.16 15.1 4.69 15.82 5.41 16.33C6.13 16.84 7.02 17.12 7.92 17.12C6.37 18.34 4.39 19.01 2.35 19C2 19 1.65 18.98 1.31 18.93C3.37 20.24 5.79 21 8.41 21C16 21 20.18 14.67 20.18 9.16C20.18 8.97 20.18 8.79 20.17 8.6C21.01 7.99 21.74 7.23 22.32 6.37L22.46 6Z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#" class="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.05 3H4.95C3.87 3 3 3.87 3 4.95V19.05C3 20.13 3.87 21 4.95 21H19.05C20.13 21 21 20.13 21 19.05V4.95C21 3.87 20.13 3 19.05 3ZM8.55 18.75H5.7V9.75H8.55V18.75ZM7.125 8.475C6.225 8.475 5.475 7.725 5.475 6.825C5.475 5.925 6.225 5.175 7.125 5.175C8.025 5.175 8.775 5.925 8.775 6.825C8.775 7.725 8.025 8.475 7.125 8.475ZM18.75 18.75H15.9V14.325C15.9 13.125 15.9 11.55 14.175 11.55C12.45 11.55 12.225 12.9 12.225 14.25V18.75H9.375V9.75H12.075V11.025H12.15C12.6 10.275 13.575 9.525 15 9.525C17.925 9.525 18.75 11.7 18.75 14.475V18.75Z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#" class="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 16.84 5.44 20.87 10 21.8V15H8V12H10V9.5C10 7.57 11.57 6 13.5 6H16V9H14C13.45 9 13 9.45 13 10V12H16V15H13V21.95C18.05 21.45 22 17.19 22 12Z" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p class="copyright">© {{ currentYear }} {{ $t('brand.copyright') }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'FooterComponent',
  setup() {
    const currentYear = computed(() => new Date().getFullYear())
    
    return {
      currentYear
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: var(--card-background);
  padding-top: 60px;
  margin-top: 60px;
  border-top: 1px solid var(--border-color);
}

.footer-top {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  padding-bottom: 40px;
}

.footer-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 24px;
  color: var(--text-primary);
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 16px;
}

.footer-link {
  color: var(--text-secondary);
  text-decoration: none;
  transition: color 0.2s;
  font-size: 14px;
}

.footer-link:hover {
  color: var(--primary-color);
}

.footer-text {
  color: var(--text-secondary);
  line-height: 1.6;
  font-size: 14px;
}

.footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.footer-logo-img {
  height: 32px;
  margin-right: 8px;
}

.footer-logo-text {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
}

.footer-social {
  display: flex;
  gap: 16px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--hover-color);
  color: var(--text-secondary);
  transition: all 0.2s;
}

.social-link:hover {
  background-color: var(--primary-color);
  color: white;
  transform: translateY(-3px);
}

.footer-bottom {
  border-top: 1px solid var(--border-color);
  padding: 24px 0;
  text-align: center;
}

.copyright {
  color: var(--text-tertiary);
  font-size: 14px;
}

@media (max-width: 768px) {
  .footer-top {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
}

@media (max-width: 480px) {
  .footer-top {
    grid-template-columns: 1fr;
  }
}
</style>
